import React, { useState, useRef, useEffect, useCallback } from "react";
import {
  Form,
  Input,
  Button,
  Space,
  Typography,
  Card,
  Col,
  Row,
  TimePicker,
  notification,
  DatePicker,
  Select,
  Modal,
  message,
  Popconfirm,
  Tag,
  Transfer,
  Drawer,
  Radio,
  Upload,
} from "antd";
import {
  UploadOutlined,
  AimOutlined,
  DeleteOutlined,
  MinusCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import { useSelector } from "react-redux";
import "../../Visitas/style.css";
import cargarDeptosMunicipios from "../../../services/departMunic/deptosMunicipiosServices";

//Mapa
import {
  MapContainer,
  TileLayer,
  LayersControl,
  useMapEvents,
} from "react-leaflet";
import { PlusOutlined } from "@ant-design/icons";

import "leaflet/dist/leaflet.css";
import ImagenUploader from "./ImagenUploader";
import moment from "moment";
import FirmaCanvas from "../../firma_electronica/firma";
import {
  getAllsd_Sostenibilidad,
  getPoasSostenibilidad,
} from "../../../services/sostenibilidad/poaSosteibilidad";
import ParticipanteForm from "../participantes/FormParticipanteSostenibilidad";
import insertVisitaTecnicasostenibilidad, {
  AlmacenarSoportesVisitaTecnicasostenibilidad,
  updateVisitaTecnicaSostenibilidad,
} from "../../../services/sostenibilidad/visitaTecnicaSostenibilidad/viistaTecnicaSostenibilidadService";
import config from "../../../config";

const { Title } = Typography;
const { Option } = Select;
const { BaseLayer } = LayersControl;
const baseUrl = config.baseUrl;

const tagStyle = {
  color: "#145BAD",
  fontSize: "15px",
  fontWeight: "bold",
  padding: "8px 15px",
  borderRadius: "8px",
  textAlign: "left",
  display: "block",
  marginBottom: "15px",
  marginTop: "20px",
  width: "100%",
  wordWrap: "break-word", // Asegura que el texto se divida en múltiples líneas
  wordBreak: "break-word", // Rompe palabras largas que no caben
  whiteSpace: "normal", // Permite que el texto se ajuste en varias líneas
};

const FormularioVisitaTecnicaSostenibilidad = ({
  initialData,
  onClose,
  fetchData,
}) => {
  const [form] = Form.useForm();
  const [formParticipante] = Form.useForm();

  const [formLoaded, setFormLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const usernameFromState = useSelector((state) => state.auth.user);
  const [datosProyecto, setDatosProyecto] = useState({});
  const [modalVisible, setModalVisible] = useState(null);
  const [modalKey, setModalKey] = useState(0);

  const [codigoInternoModal, setCodigoInternoModal] = useState("");

  const [departamentosxmunicipio, setDepartamentosxmunicipio] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState("");
  const [municipios, setMunicipios] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isOtra, setIsOtra] = useState(false);
  const [modalidadSesionCapacitacion, setModalidadSesionCapacitacion] =
    useState(false);

  // Estados para controlar carga y estado de cada campo de imagen
  const [loadingStatus, setLoadingStatus] = useState({});
  const [readyStatus, setReadyStatus] = useState({});
  const [isDirty, setIsDirty] = useState(false);
  
  //Estado para almacenar la lista de sd_sostenibilidad
  const [lista_sd_sostenibilidad, setLista_sd_sostenibilidad] = useState([]);

  //Estado para almacenar la lista de participantes por proyecto
  const [
    listaParticipantesSostenibilidadByProyecto,
    setListaParticipantesSostenibilidadByProyecto,
  ] = useState([]);
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);

  const [
    dataFactoresxactividadxsubActividades,
    setDataFactoresxactividadxsubActividades,
  ] = useState([]);
  // Agregar nuevo estado para lista de factores
  const [factores, setFactores] = useState([]);

  const [selectedFactor, setSelectedFactor] = useState([]);

  // Agregar nuevo estado para lista de actividades por factor
  const [actividadesFiltradas, setActividadesFiltradas] = useState({});
  // Agregar nuevo estado para lista de subactividades por actividad
  const [subActividadesFiltradas, setSubActividadesFiltradas] = useState({});

  const [ultima_visita, setUltima_visita] = useState([]);

  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const mapRef = useRef();

  const [modoFirma, setModoFirma] = useState("firma_participantes");

  //Inicializar el marcador del mapa
  const [markerPosition, setMarkerPosition] = useState(() => {
    if (form?.latuser && form?.lnguser) {
      return [form.latuser, form.lnguser];
    } else {
      return [4.570868, -74.297333];
    }
  });


      // Lista de nombres de campos de imagen
  const imageFields = [
    'fotografia_participantes',
    'fotografias_lugar',
    'fotografia_finalidad',
    'fotografia_acta',
    'fotografia_actividad'
  ];

      // Detectar cambios en cualquier campo del formulario
  const onValuesChange = (changedValues, allValues) => {
    checkIfDirty();
  };


    // Función para verificar si el formulario ha cambiado
  const checkIfDirty = () => {
    const currentValues = form.getFieldsValue();
    // Comparación profunda con los valores iniciales
    const initial = initialData.current || {};
    // Usamos JSON.stringify para comparar (considerar que las imágenes pueden ser arrays grandes)
    const isEqual = JSON.stringify(currentValues) === JSON.stringify(initial);
    setIsDirty(!isEqual);
  };
  
  const handleFotografiaParticipantesChange = useCallback((imagenesBase64) => {
    form.setFieldsValue({ fotografia_participantes: imagenesBase64 });
  }, [form]);

  const handleFotografiasLugarChange = useCallback((imagenesBase64) => {
    form.setFieldsValue({ fotografias_lugar: imagenesBase64 });
  }, [form]);
  
  const handleFotografiaFinalidadChange = useCallback((imagenesBase64) => {
    form.setFieldsValue({ fotografia_finalidad: imagenesBase64 });
  }, [form]);
  
  const handleFotografiaActaChange = useCallback((imagenesBase64) => {
    form.setFieldsValue({ fotografia_acta: imagenesBase64 });
  }, [form]);
  
  const handleFotografiaActividadChange = useCallback((imagenesBase64) => {
    form.setFieldsValue({ fotografia_actividad: imagenesBase64 });
  }, [form]);
  


  // Función recursiva para obtener padres con hijos finales dentro de un Factor
  const obtenerPadresConHijosFinales = (nodo) => {
    let resultados = [];

    if (nodo.children) {
      let hijosFinales = nodo.children
        .filter((child) => child.isFinal === "yes")
        .map((child) => ({
          key: child.key, // Se mantiene la clave original de la subActividad
          title: child.title,
        }));

      if (hijosFinales.length > 0) {
        resultados.push({
          key: nodo.key, // Se mantiene la clave original de la actividad
          actividad: nodo.title,
          subActividades: hijosFinales,
        });
      }

      nodo.children.forEach((child) => {
        resultados = resultados.concat(obtenerPadresConHijosFinales(child));
      });
    }

    return resultados;
  };

  // Función para estructurar la salida con Super Padres
  const obtenerSuperPadres = (data) => {
    return data.flatMap(
      (obj) =>
        obj.children?.map((factor) => ({
          key: factor.key,
          factor: factor.title,
          actividades: obtenerPadresConHijosFinales(factor),
        })) || []
    );
  };

  const handleFactorChange = async (factorKey, index) => {
    // Buscar el factor seleccionado
    const factorSeleccionado = dataFactoresxactividadxsubActividades.find(
      (factor) => factor.factor === factorKey
    );

    if (!factorSeleccionado) {
      console.error(`Factor con key ${factorKey} no encontrado.`);
      return;
    }

    // Actualizar actividades filtradas
    setActividadesFiltradas((prev) => ({
      ...prev,
      [index]: factorSeleccionado.actividades || [],
    }));

    // Limpiar subactividades filtradas
    setSubActividadesFiltradas((prev) => ({
      ...prev,
      [index]: [],
    }));

    // Resetear actividad y subActividad en el formulario
    form.setFieldsValue({
      lista_factores: form
        .getFieldValue("lista_factores")
        .map((item, i) =>
          i === index
            ? { ...item, actividad: undefined, subActividad: undefined }
            : item
        ),
    });

    // Esperar un momento para que se actualicen los estados
    await new Promise((resolve) => setTimeout(resolve, 100));
  };
  const handleActividadChange = async (actividadKey, index) => {
    if (!actividadesFiltradas[index]) {
      return;
    }

    const actividadSeleccionada = actividadesFiltradas[index]?.find(
      (actividad) => actividad.actividad === actividadKey
    );

    if (!actividadSeleccionada) {
      console.error(
        `Actividad con key ${actividadKey} no encontrada en el índice ${index}.`
      );
      return;
    }

    // Actualizar subactividades filtradas
    setSubActividadesFiltradas((prev) => ({
      ...prev,
      [index]: actividadSeleccionada.subActividades || [],
    }));

    // Resetear solo el campo subActividad en el formulario
    form.setFieldsValue({
      lista_factores: form
        .getFieldValue("lista_factores")
        .map((item, i) =>
          i === index ? { ...item, subActividad: undefined } : item
        ),
    });

    await new Promise((resolve) => setTimeout(resolve, 100));
  };

  // Componente para el marcador y actualizar latitud, longitud y altitud en el formulario
  const LocationMarker = () => {
    useMapEvents({
      async click(e) {
        const { lat, lng } = e.latlng;

        // Actualizar latitud, longitud y posición del marcador
        setLatitude(lat.toFixed(6));
        setLongitude(lng.toFixed(6));
        setMarkerPosition([lat, lng]);
        form.setFieldsValue({
          latuser: lat.toFixed(6),
          lnguser: lng.toFixed(6),
        });
      },
    });

    return null; // Este componente no necesita renderizar nada visible
  };

  //Obtener datos de geolocalización or mi ubicación
  const handleLocateClick = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          // Actualizar los estados con la latitud y longitud
          const latNum = Number(latitude.toFixed(6)); // Asegúrate de que sea un número
          const lngNum = Number(longitude.toFixed(6)); // Asegúrate de que sea un número

          setLatitude(latNum);
          setLongitude(lngNum);
          setMarkerPosition([latNum, lngNum]);

          // Configurar los valores del formulario
          form.setFieldsValue({
            latuser: latNum,
            lnguser: lngNum,
          });

          const map = mapRef.current;
          if (map) {
            // Espera a que el mapa esté listo
            setTimeout(() => {
              map.flyTo([latNum, lngNum], 13); // Mover el mapa a la ubicación actual
            }, 100); // Ajusta el tiempo según sea necesario
          }
        },
        (error) => {
          console.error("Error obteniendo la ubicación:", error);
          // Puedes agregar lógica aquí para manejar el error, como mostrar un mensaje al usuario.
        }
      );
    } else {
      console.error("Geolocalización no es soportada por este navegador.");
    }
  };

  //maneja el cambio de estado del departamento
  const handleDepartamentoChange = (valor) => {
    setMunicipios([]);
    form.setFieldsValue({ municipio: undefined });
    setDepartamentoSeleccionado(valor);
    const lista_municipios = departamentosxmunicipio.find(
      (dep) => dep.nombre_departamento === valor
    );

    if (lista_municipios && lista_municipios.municipios) {
      // Ordenar la lista de municipios alfabéticamente por nombre
      const municipiosOrdenados = lista_municipios.municipios.sort((a, b) => {
        if (a.nombre_municipio < b.nombre_municipio) return -1;
        if (a.nombre_municipio > b.nombre_municipio) return 1;
        return 0;
      });

      // Actualizar el estado con la lista de municipios ordenada
      setMunicipios(municipiosOrdenados);
    } else {
      setMunicipios([]);
      form.setFieldsValue({ municipio: undefined });
    }
  };

  //Obtener lista de departamentos x municipio
  const obtenerdepartamentos = useCallback(async () => {
    try {
      setDepartamentos([]);
      form.setFieldsValue({ departamentos: [] });

      const { data } = await cargarDeptosMunicipios();
      setDepartamentosxmunicipio(data);

      let uniqueDepartamentos = data.map((departamento) => ({
        id: departamento.oid_departamento,
        nombre: departamento.nombre_departamento,
      }));

      setDepartamentos(uniqueDepartamentos);
    } catch (error) {
      console.error("Error al obtener departamentos:", error);
    }
  }, [form]);


   // Handlers para cada instancia
  const handleLoadingChange = (name, isLoading) => {
    setLoadingStatus(prev => ({ ...prev, [name]: isLoading }));
  };

    const handleStatusChange = (name, isReady) => {
    setReadyStatus(prev => ({ ...prev, [name]: isReady }));
  };

      // Función que determina si todas las imágenes están listas
  const allImagesReady = () => {
    // Si algún campo está cargando, no está listo
    const hasLoading = Object.values(loadingStatus).some(v => v === true);
    if (hasLoading) return false;

    // Verificar que todos los campos tengan estado ready y sea true
    for (const field of imageFields) {
      // Si aún no se ha registrado el estado (undefined), lo consideramos no listo
      if (readyStatus[field] === undefined) return false;
      if (readyStatus[field] === false) return false;
    }
    return true;
  };

  //Obtener lista de departamentos x municipio
  const obtenerSdSostenibilidad = useCallback(async () => {
    try {
      setLista_sd_sostenibilidad([]);

      const { data } = await getAllsd_Sostenibilidad();
      setLista_sd_sostenibilidad(data);
    } catch (error) {
      console.error("Error al obtener departamentos:", error);
    }
  }, [form]);

  // Primer useEffect para consultar API
  useEffect(() => {
    if (initialData && initialData.codigo_interno && isEditing) {
      consultarAPI(initialData.codigo_interno);
    }
  }, [initialData?.codigo_interno, isEditing]); // Solo depende de estos valores

  
  useEffect(() => {
    if (!datosProyecto?.poas || !Array.isArray(datosProyecto.poas)) {
      return;
    } else {
      const resultado = obtenerSuperPadres(datosProyecto.poas);

      const factoresNuevos = resultado.map((item) => ({
        key: item.key,
        factor: item.factor,
      }));

      setFactores(factoresNuevos);
      setDataFactoresxactividadxsubActividades(resultado);

      form.setFieldsValue({
        departamento: datosProyecto.departamento,
        municipio: datosProyecto.municipio,
        grupoTerritorial: datosProyecto.grupo_territorial,
        linea_productiva: datosProyecto.sector,
        codigoPREPP: datosProyecto.codigo_pre,
        nombreProyecto: datosProyecto.nombre_proyecto,
        nombreFormaAsociativa: datosProyecto.nombre_asociativa,
      });
    }
  }, [datosProyecto.poas]);

  // Segundo useEffect para manejar la inicialización del formulario
  useEffect(() => {
    // 1. Primero obtenemos los departamentos
    obtenerdepartamentos();

    obtenerSdSostenibilidad();
    // 2. Manejamos el estado inicial del formulario
    if (initialData && Object.keys(initialData).length > 0) {
      setModalVisible(false);
      setIsEditing(true);
      setSelectedParticipants(initialData?.participantes || []);
      setModoFirma(initialData.modoFirma || "firma_participantes");

      // Asegurar conversión segura de horaInicio y horaFin a objetos moment
      const horaInicio =
        typeof initialData.horaInicio === "string"
          ? moment(initialData.horaInicio, "hh:mm a")
          : null;

      const horaFin =
        typeof initialData.horaFin === "string"
          ? moment(initialData.horaFin, "hh:mm a")
          : null;

      const proximaSesion = initialData.proximaSesion
        ? moment(initialData.proximaSesion)
        : null;

      // Convertir fechas dentro de la lista de acuerdos de forma segura
      const acuerdos = Array.isArray(initialData.acuerdos)
        ? initialData.acuerdos.map((acuerdo) => ({
            ...acuerdo,
            fechaLimite: acuerdo?.fechaLimite
              ? moment(acuerdo.fechaLimite)
              : null,
          }))
        : [];

      const anexoFirmasValue = initialData.anexoFirmas
        ? [
            {
              uid: "-1",
              name: "anexo.pdf",
              status: "done",
              url: `${baseUrl}${initialData.anexoFirmas}`,
            },
          ]
        : []; // 👈 vacío si no existe

      form.setFieldsValue({
        ...initialData,
        horaInicio,
        horaFin,
        proximaSesion,
        acuerdos,
        anexoFirmas: anexoFirmasValue,
      });

      setFormLoaded(true);
    } else {
      setModalVisible(true);
      setIsEditing(false);
      // Limpiar el formulario
      form.resetFields();

      // Establecer la fecha actual
      const fechaActual = new Date().toISOString().split("T")[0];
      form.setFieldsValue({
        fecha_registro: fechaActual,
        modoFirma: "firma_participantes",
      });
    }
  }, [form, obtenerdepartamentos, initialData]); // Agregar factores como dependencia

  // Nuevo useEffect para procesar lista_factores
  useEffect(() => {
    if (initialData.lista_factores && factores.length > 0) {
      const procesarFactores = async () => {
        for (
          let index = 0;
          index < initialData.lista_factores.length;
          index++
        ) {
          const factor = initialData.lista_factores[index];

          // Primero cargar las actividades del factor
          const factorSeleccionado = dataFactoresxactividadxsubActividades.find(
            (f) => f.key === factor.factor
          );
          if (!factorSeleccionado) {
            console.error(`Factor con key ${factor.factor} no encontrado.`);
            continue;
          }

          const actividades = factorSeleccionado.actividades || [];

          // Actualizar actividades filtradas en el estado
          setActividadesFiltradas((prev) => ({
            ...prev,
            [index]: actividades,
          }));

          // Luego cargar las subactividades si hay una actividad seleccionada
          if (factor.actividad) {
            const actividadSeleccionada = actividades.find(
              (a) => a.key === factor.actividad
            );
            if (actividadSeleccionada) {
              setSubActividadesFiltradas((prev) => ({
                ...prev,
                [index]: actividadSeleccionada.subActividades || [],
              }));
            }
          }

          // Actualizar el formulario con los valores
          form.setFieldsValue({
            lista_factores: form
              .getFieldValue("lista_factores")
              .map((item, i) =>
                i === index
                  ? {
                      ...item,
                      factor: factor.factor,
                      actividad: factor.actividad,
                      subActividad: factor.subActividad,
                    }
                  : item
              ),
          });
        }
      };
      procesarFactores();
    }
  }, [
    initialData.lista_factores,
    factores,
    dataFactoresxactividadxsubActividades,
    form,
  ]);

  const agregarParticipanteLocal = async (participante) => {
    setListaParticipantesSostenibilidadByProyecto((prevLista) => [
      ...prevLista,
      participante,
    ]);
  };

  const consultarAPI = async (codigo) => {
    try {
      const data = await getPoasSostenibilidad(codigo);
      if (data) {
        setDatosProyecto(data);
        setListaParticipantesSostenibilidadByProyecto(data.participantes);

        if (!isEditing) {
          form.setFieldsValue({
            numero_visita: data.ultima_visita,
          });
          setUltima_visita(data.ultima_visita);
        }
        setModalVisible(false);
      }
    } catch (error) {
      console.error("Error en consultarAPI:", error);
      notification.error({
        message: "Error",
        description: "No se encontraron datos para el código ingresado.",
      });
      setModalVisible(true);
    }
  };

  const handleConsultar = async () => {
    try {
      if (!codigoInternoModal.trim()) {
        notification.error({
          message: "Error",
          description: "Por favor ingresa un código interno.",
        });
        return;
      }
      await consultarAPI(codigoInternoModal);
    } catch (error) {
      message.error({
        message: "Error",
        description: "No se pudo realizar la consulta. Intente nuevamente.",
      });
    }
  };

  const onFinish = async () => {

    if (!isAllReady) {
        message.warning('Aún hay imágenes cargando o con errores.');
        return;
    }
    setIsLoading(true);
    try {
      // Obtiene los valores actualizados del formulario
      const values = form.getFieldsValue();

      // Formatear horaInicio si es un objeto `moment`
      if (values.horaInicio) {
        values.horaInicio = values.horaInicio.format("hh:mm a");
      }

      // Formatear horaFin si es un objeto `moment`
      if (values.horaFin) {
        values.horaFin = values.horaFin.format("hh:mm a");
      }
      // Formatear proximaSesion si es un objeto `moment`
      if (values.proximaSesion) {
        values.proximaSesion = values.proximaSesion.format("YYYY/MM/DD");
      }
      // Formatear fechas dentro de la lista de acuerdos
      if (Array.isArray(values.acuerdos)) {
        values.acuerdos = values.acuerdos.map((acuerdo) => ({
          ...acuerdo,
          fechaLimite: acuerdo?.fechaLimite
            ? acuerdo.fechaLimite.format("YYYY/MM/DD")
            : null,
        }));
      }

      // Verifica si es edición o inserción y ejecuta la acción correspondiente
      if (isEditing) {
        await actualizarVisitaTecnica(values);
      } else {
        await insertarVisitaTecnica(values, initialData);
      }
    } catch (error) {
      console.error("Error al guardar la visita técnica:", error);
    } finally {
      setIsLoading(false); // Asegura que el botón se desbloquee incluso si hay un error
    }
  };

const insertarVisitaTecnica = async (values, initialData) => {

  let clavesFirmas = [
    "firmaProfesionalAsistenteTecnico",
    "firmaProfesionalAsistenteTecnico_2",
    "fotografia_participantes",
    "fotografias_lugar",
    "fotografia_finalidad",
    "fotografia_acta",
    "fotografia_actividad",
    "anexoFirmas",
  ];

  // Agregar dinámicamente los valores de participantes
  selectedParticipants.forEach((participante) => {
    clavesFirmas.push(`firmaParticipante_${participante.id}`);
  });


  // Filtrar valores eliminando las claves de imágenes
  const valoresFiltrados = Object.fromEntries(
    Object.entries(values).filter(([key]) => !clavesFirmas.includes(key))
  );


  let data = {};
  let result = null;

  try {
    // =====================================================
    // 1. CONSTRUIR DATA PRINCIPAL
    // =====================================================
    const baseData = {
      ...valoresFiltrados,
      fuente: "Web",
      user_email: usernameFromState.email,
    };

    data = {
      detalle: baseData,
      numero_visita: ultima_visita,
      id_sostenibilidad: datosProyecto.id_sostenibilidad,
      tipo_envio: "Envio",
    };

    // =====================================================
    // 2. INSERTAR VISITA TÉCNICA
    // =====================================================
    result = await insertVisitaTecnicasostenibilidad(data);

    // =====================================================
    // 3. VALIDAR RESPUESTA DE INSERCIÓN
    // =====================================================
    if (!result || result.status !== 200) {
      notification.error({
        message: "Error al guardar la visita",
        description: result?.message || "No se pudo guardar la visita técnica. Verifique los datos e intente nuevamente.",
        duration: 5,
      });
      return; // Salir sin cerrar modal
    }

    // =====================================================
    // 4. VERIFICAR SI HAY SOPORTES
    // =====================================================
    const tieneSoportes = clavesFirmas.some((key) => {
      const valor = values[key];
      if (!valor) return false;
      if (Array.isArray(valor)) return valor.length > 0;
      if (typeof valor === 'string') return valor.trim() !== '';
      return false;
    });

    // =====================================================
    // 5. SI NO HAY SOPORTES → FINALIZAR
    // =====================================================
    if (!tieneSoportes) {
      notification.success({
        message: "Visita guardada correctamente",
        description: "La visita técnica fue guardada sin registros fotográficos.",
        duration: 4,
      });
      onClose();
      fetchData();
      return;
    }

    // =====================================================
    // 6. ENVIAR SOPORTES
    // =====================================================

    let respuestaSoportes = null;
    try {
      respuestaSoportes = await envioSoportesVisitaTecnica(
        values,
        result.id,
        codigoInternoModal,
        initialData,
        selectedParticipants
      );

    } catch (error) {
      console.error("❌ Error al enviar soportes:", error);
      // No lanzamos el error, continuamos con el flujo
    }

    // =====================================================
    // 7. VALIDAR RESPUESTA DE SOPORTES
    // =====================================================
    if (!respuestaSoportes || respuestaSoportes.status !== 200) {
      // ⚠️ La visita se guardó pero los soportes fallaron
      
      notification.warning({
        message: "Visita guardada parcialmente",
        description: 
          respuestaSoportes?.message === "No hay cambios en las imágenes local" ||
          respuestaSoportes?.message === "No se enviaron imágenes nuevas"
            ? "La visita fue guardada correctamente. No se detectaron cambios en los soportes."
            : "La visita fue guardada correctamente, pero no se pudieron guardar los soportes. Verifique los archivos e intente nuevamente.",
        duration: 6,
      });
      
      // Cerrar modal y recargar datos (la visita ya está guardada)
      onClose();
      fetchData();
      return;
    }

    // =====================================================
    // 8. TODO EXITOSO
    // =====================================================
    
    notification.success({
      message: "Visita guardada correctamente",
      description: "La visita técnica y sus soportes fueron guardados correctamente.",
      duration: 4,
    });

    onClose();
    fetchData();

  } catch (error) {
    // =====================================================
    // 9. ERROR GENERAL
    // =====================================================
    
    // Verificar si el error viene del backend
    const errorMessage = error?.response?.data?.message || 
                         error?.message || 
                         "No se pudo guardar la visita técnica.";

    notification.error({
      message: "Error al guardar la visita",
      description: errorMessage,
      duration: 6,
    });
    
    // No cerrar modal para que el usuario pueda corregir
    return;
  }
};

// Función para actualizar una visita técnica existente
const actualizarVisitaTecnica = async (values) => {
  // =====================================================
  // 1. CLAVES DE FIRMAS Y SOPORTES
  // =====================================================

  const  clavesImagenes = [
    "firmaProfesionalAsistenteTecnico",
    "firmaProfesionalAsistenteTecnico_2",
    "fotografia_participantes",
    "fotografias_lugar",
    "fotografia_finalidad",
    "fotografia_acta",
    "fotografia_actividad",
  ];

  // =====================================================
  // 2. AGREGAR FIRMAS SEGÚN EL MODO DE FIRMA
  // =====================================================

  if (values.modoFirma === "firma_participantes") {
    selectedParticipants.forEach((participante) => {
      clavesImagenes.push(`firmaParticipante_${participante.id}`);
    });
  } else if (values.modoFirma === "anexo_firma_participantes") {
    clavesImagenes.push("anexoFirmas");
  } else {
    selectedParticipants.forEach((participante) => {
      clavesImagenes.push(`firmaParticipante_${participante.id}`);
    });
  }

  // =====================================================
  // 3. FILTRAR LOS DATOS QUE NO SE ENVÍAN
  //    EN LA ACTUALIZACIÓN PRINCIPAL
  // =====================================================

  const valoresFiltrados = Object.fromEntries(
    Object.entries(values).filter(
      ([key]) => !clavesImagenes.includes(key)
    )
  );

  // =====================================================
  // 4. DETERMINAR SI EXISTEN SOPORTES PARA ENVIAR
  // =====================================================

  const tieneSoportes = clavesImagenes.some((key) => {
    const valor = values[key];

    if (!valor) {
      return false;
    }

    if (Array.isArray(valor)) {
      return valor.length > 0;
    }

    if (typeof valor === "string") {
      return valor.trim() !== "";
    }

    return false;
  });

  
  try {
    // =====================================================
    // 5. CONSTRUIR DATA PRINCIPAL
    // =====================================================

    const data = {
      ...valoresFiltrados,
      fuente: initialData.fuente,
      codigo_interno: initialData.codigo_interno,
      user_email: initialData.user_email,
    };

    // =====================================================
    // 6. ACTUALIZAR DATOS PRINCIPALES
    // =====================================================

    const result = await updateVisitaTecnicaSostenibilidad(
      initialData.id,
      data,
      usernameFromState.email
    );

    // =====================================================
    // 7. VALIDAR ACTUALIZACIÓN PRINCIPAL
    // =====================================================

    if (!result || result.status !== 200) {
      notification.error({
        message: "No se pudo actualizar la visita",
        description:
          result?.message ||
          "Ocurrió un error al guardar los datos de la visita técnica.",
      });

      // No continuar con soportes
      // No cerrar modal
      return;
    }

    // =====================================================
    // 8. SI NO HAY SOPORTES
    // =====================================================

    if (!tieneSoportes) {

      notification.success({
        message: "Visita actualizada correctamente",
        description:
          "Los datos de la visita técnica fueron actualizados correctamente.",
      });

      onClose();
      fetchData();

      return;
    }

    // =====================================================
    // 9. ENVIAR SOPORTES
    // =====================================================

    try {
      const respuestaSoportes =
        await envioSoportesVisitaTecnica(
          values,
          initialData.id,
          initialData.codigo_interno,
          initialData,
          selectedParticipants
        );

      // =====================================================
      // 10. VALIDAR RESPUESTA DE SOPORTES
      // =====================================================

      if (
        !respuestaSoportes ||
        respuestaSoportes === false ||
        respuestaSoportes.status !== 200
      ) {
        notification.warning({
          message: "Visita actualizada, soportes pendientes",
          description:
            respuestaSoportes?.message ||
            "Los datos de la visita fueron actualizados correctamente, pero los soportes no pudieron cargarse. Verifique los archivos e intente nuevamente.",
        });

        // IMPORTANTE:
        // Los datos sí fueron guardados,
        // pero dejamos el modal abierto para que
        // el usuario pueda intentar nuevamente.
        return;
      }

      // =====================================================
      // 11. TODO FUE EXITOSO
      // =====================================================

      notification.success({
        message: "Visita actualizada correctamente",
        description:
          "Los datos y los soportes de la visita técnica fueron actualizados correctamente.",
      });

      // Cerrar modal
      onClose();

      // Recargar información
      fetchData();

    } catch (error) {
      // =====================================================
      // 12. ERROR AL ENVIAR SOPORTES
      // =====================================================

      notification.warning({
        message: "Visita actualizada, soportes pendientes",
        description:
          "Los datos de la visita fueron actualizados correctamente, pero ocurrió un error al cargar los soportes. Verifique los archivos e intente nuevamente.",
      });

      // No cerrar modal
      return;
    }

  } catch (error) {
    // =====================================================
    // 13. ERROR GENERAL
    // =====================================================

    notification.error({
      message: "Error al actualizar la visita",
      description:
        "Ocurrió un error inesperado al actualizar la visita técnica. Verifique la información e intente nuevamente.",
    });

    // No cerrar modal
    return;
  }
   };

  // Convertir una cadena Base64 a un objeto File
  const base64ToFile = (base64String, index) => {
    const arr = base64String.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    if (!mimeMatch) {
      throw new Error("Formato Base64 incorrecto.");
    }
    const mime = mimeMatch[1];
    const extension = mime.split("/")[1]; // Extraer la extensión del archivo
    const bstr = atob(arr[1]); // Decodificar Base64
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    // Asignar un nombre único usando `Date.now()` y el índice
    const filename = `${Date.now()}-${index}.${extension}`;
    return new File([u8arr], filename, { type: mime });
  };

  async function urlToFile(url, filename) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new File([blob], filename, { type: blob.type });
    } catch (error) {
      console.error("❌ Error al convertir url a File:", error);
      return null;
    }
  }

const envioSoportesVisitaTecnica = async (
  values,
  id_registro,
  codigo_interno,
  initialData,
  selectedParticipants = []
) => {
  const formData = new FormData();
  formData.append("codigo_interno", codigo_interno);
  formData.append("id_visita", id_registro);
  formData.append("usuario_id", usernameFromState.email);

  // Definir campos de imagen base
  const baseImageFields = [
    {
      key: "firmaProfesionalAsistenteTecnico",
      type: "firmaProfesionalAsistenteTecnico",
    },
    {
      key: "firmaProfesionalAsistenteTecnico_2",
      type: "firmaProfesionalAsistenteTecnico_2",
    },
    { key: "fotografia_participantes", type: "fotografia_participantes" },
    { key: "fotografias_lugar", type: "fotografias_lugar" },
    { key: "fotografia_finalidad", type: "fotografia_finalidad" },
    { key: "fotografia_acta", type: "fotografia_acta" },
    { key: "fotografia_actividad", type: "fotografia_actividad" },
    { key: "anexoFirmas", type: "anexoFirmas" },
  ];

  // Agregar firmas de participantes dinámicamente
  const imageFields = [...baseImageFields];
  selectedParticipants.forEach((participante) => {
    const key = `firmaParticipante_${participante.id}`;
    imageFields.push({ key, type: key });
  });

  // =====================================================
  // FUNCIÓN PARA NORMALIZAR ANEXOFIRMAS
  // =====================================================
  const normalizarAnexoFirmas = (valor) => {

    if (!valor) {
      console.log("   ❌ Valor vacío o nulo");
      return null;
    }

    // Si es string (ruta)
    if (typeof valor === 'string') {
      const limpio = valor.replace(/^\/+/, '').trim();
      return limpio;
    }

    // Si es array de Upload Ant Design
    if (Array.isArray(valor) && valor.length > 0) {
      const firstItem = valor[0];

      // Extraer URL
      const url = firstItem?.url || firstItem?.response?.url || '';

      if (url) {
        // Remover dominio y barras iniciales
        const path = url.replace('https://166.bodecom.com', '').replace(/^\/+/, '').trim();
        return path;
      }

      // Si no tiene URL pero tiene nombre (archivo nuevo)
      if (firstItem?.name) {
        return firstItem.name;
      }
    }

    return null;
  };

  // =====================================================
  // FUNCIÓN DE COMPARACIÓN MEJORADA
  // =====================================================
  const sonIguales = (a, b, fieldName = '') => {

    // Comparar valores null/undefined
    if (a === b) {
      return true;
    }
    if (a === null || a === undefined || b === null || b === undefined) {
      return a === b;
    }

    // 🔹 Caso especial: anexoFirmas (string vs array)
    if (fieldName === 'anexoFirmas') {
      const aNorm = normalizarAnexoFirmas(a);
      const bNorm = normalizarAnexoFirmas(b);
      const resultado = aNorm === bNorm;
      return resultado;
    }

    // 🔹 Caso especial: string vs array de Upload (1 elemento)
    if (typeof a === 'string' && Array.isArray(b) && b.length === 1) {
      const bItem = b[0];
      const bUrl = bItem?.url || bItem?.response?.url || '';
      const bPath = bUrl.replace('https://166.bodecom.com', '').replace(/^\/+/, '').trim();
      const aClean = a.replace(/^\/+/, '').trim();
      const resultado = aClean === bPath;
      return resultado;
    }

    // 🔹 Caso especial: array de Upload vs string
    if (Array.isArray(a) && typeof b === 'string' && a.length === 1) {
      const aItem = a[0];
      const aUrl = aItem?.url || aItem?.response?.url || '';
      const aPath = aUrl.replace('https://166.bodecom.com', '').replace(/^\/+/, '').trim();
      const bClean = b.replace(/^\/+/, '').trim();
      const resultado = aPath === bClean;
      return resultado;
    }

    // Comparar strings (trim para ignorar espacios)
    if (typeof a === 'string' && typeof b === 'string') {
      const resultado = a.trim() === b.trim();
      return resultado;
    }

    // Comparar arrays de objetos (Upload Ant Design)
    if (Array.isArray(a) && Array.isArray(b)) {      
      if (a.length === 0 && b.length === 0) {
        return true;
      }
      
      if (a.length !== b.length) {
        return false;
      }
      
      // Comparar cada elemento
      const resultado = a.every((item, index) => {
        const bItem = b[index];
        
        if (typeof item === 'object' && typeof bItem === 'object') {
          const aUrl = item.url || item.response?.url || '';
          const bUrl = bItem.url || bItem.response?.url || '';
          
          if (aUrl && bUrl) {
            const aPath = aUrl.replace('https://166.bodecom.com', '').replace(/^\/+/, '').trim();
            const bPath = bUrl.replace('https://166.bodecom.com', '').replace(/^\/+/, '').trim();
            const igual = aPath === bPath;
            return igual;
          }
          
          const igual = item.name === bItem.name && item.uid === bItem.uid;
          return igual;
        }
        
        const igual = item === bItem;
        return igual;
      });
      
      return resultado;
    }

    // Comparar objetos
    if (typeof a === 'object' && typeof b === 'object') {
      const resultado = JSON.stringify(a) === JSON.stringify(b);
      return resultado;
    }

    return false;
  };

  // =====================================================
  // 1. DETECTAR CAMBIOS
  // =====================================================

  let hayCambios = false;
  let camposConCambios = [];

  if (initialData) {
    for (const field of imageFields) {
      const valorActual = values[field.key];
      const valorInicial = initialData[field.key];
      
      const iguales = sonIguales(valorActual, valorInicial, field.key);
      
      if (!iguales) {
        hayCambios = true;
        camposConCambios.push(field.key);
      } 
    }
  } else {
    hayCambios = true;
  }

  if (!hayCambios) {
    return { status: 200, message: "No hay cambios en las imágenes local" };
  }

  // =====================================================
  // 2. PROCESAR CAMPOS
  // =====================================================

  const archivos = [];
  const camposEliminar = [];
  const urlsMantener = {};
  let fileIndex = 1;

  const esBase64 = (valor) => typeof valor === 'string' && valor.startsWith('data:image');
  const esUrl = (valor) => typeof valor === 'string' && (valor.startsWith('/') || valor.startsWith('http'));
  const estaVacio = (valor) => {
    if (valor === null || valor === undefined) return true;
    if (Array.isArray(valor)) return valor.length === 0;
    if (typeof valor === 'string') return valor.trim() === '';
    return false;
  };

  // Función para procesar anexoFirmas
  const procesarAnexoFirmas = async (valorActual, valorInicial) => {

    // Normalizar para comparar
    const actualNorm = normalizarAnexoFirmas(valorActual);
    const inicialNorm = normalizarAnexoFirmas(valorInicial);


    // Si no hay cambios en anexoFirmas, no hacer nada
    if (actualNorm === inicialNorm) {
      if (actualNorm && typeof actualNorm === 'string' && actualNorm.includes('/')) {
        urlsMantener["anexoFirmas"] = [actualNorm];
      }
      return;
    }

    // Si el actual está vacío y antes tenía valor → eliminar
    if (estaVacio(valorActual) && !estaVacio(valorInicial)) {
      camposEliminar.push("anexoFirmas");
      return;
    }

    // Si no hay valor actual, no hacer nada
    if (estaVacio(valorActual)) {
      return;
    }

    // Procesar fileList de Upload
    const fileList = valorActual?.fileList || valorActual || [];

    if (!Array.isArray(fileList) || fileList.length === 0) {
      return;
    }

    // Verificar si hay archivos nuevos (originFileObj) o existentes (url)
    const tieneArchivosNuevos = fileList.some(f => f.originFileObj);
    const tieneArchivosExistentes = fileList.some(f => f.url);


    if (!tieneArchivosNuevos && tieneArchivosExistentes) {
      // Solo URLs existentes → mantener
      const urls = fileList.map(f => f.url).filter(url => url);
      if (urls.length > 0) {
        urlsMantener["anexoFirmas"] = urls;
      }
      return;
    }

    // Procesar archivos nuevos y existentes
    for (const fileObj of fileList) {
      if (fileObj.originFileObj) {
        // Archivo nuevo
        archivos.push({
          file: fileObj.originFileObj,
          type: "anexoFirmas"
        });
      } else if (fileObj.url) {
        // Archivo existente → mantener
        const url = fileObj.url.replace('https://166.bodecom.com', '');
        if (!urlsMantener["anexoFirmas"]) {
          urlsMantener["anexoFirmas"] = [];
        }
        urlsMantener["anexoFirmas"].push(url);
      }
    }
  };

  // Procesar cada campo
  for (const field of imageFields) {
    const valorActual = values[field.key];
    const valorInicial = initialData ? initialData[field.key] : null;


    // Caso especial: anexoFirmas
    if (field.key === "anexoFirmas") {
      await procesarAnexoFirmas(valorActual, valorInicial);
      continue;
    }

    // Si el campo está vacío y antes tenía valor → marcamos para eliminar
    if (estaVacio(valorActual)) {
      if (initialData && !estaVacio(valorInicial)) {
        camposEliminar.push(field.type);
      }
      continue;
    }

    // Si es un array
    if (Array.isArray(valorActual)) {
      const urls = [];
      for (const item of valorActual) {
        if (!item || item.trim() === '') continue;
        if (esBase64(item)) {
          try {
            const file = base64ToFile(item, fileIndex, field.type);
            archivos.push({ file, type: field.type });
            fileIndex++;
          } catch (error) {
            console.error(`❌ Error al procesar base64 en ${field.key}:`, error);
          }
        } else if (esUrl(item)) {
          urls.push(item);
        }
      }
      if (urls.length > 0) {
        urlsMantener[field.type] = urls;
      }
    } else {
      // Valor string
      const valor = valorActual.trim();
      if (esBase64(valor)) {
        try {
          const file = base64ToFile(valor, fileIndex, field.type);
          archivos.push({ file, type: field.type });
          fileIndex++;
        } catch (error) {
          console.error(`❌ Error al procesar ${field.key}:`, error);
        }
      } else if (esUrl(valor)) {
        urlsMantener[field.type] = [valor];
      }
    }
  }

  // =====================================================
  // 3. SI NO HAY ARCHIVOS NUEVOS NI PARA ELIMINAR
  // =====================================================
  if (archivos.length === 0 && camposEliminar.length === 0 && Object.keys(urlsMantener).length === 0) {
    return { status: 200, message: "No se enviaron imágenes nuevas" };
  }

  // =====================================================
  // 4. CONSTRUIR FORMDATA
  // =====================================================
  if (camposEliminar.length > 0) {
    formData.append("camposEliminar", JSON.stringify(camposEliminar));
  }

  if (Object.keys(urlsMantener).length > 0) {
    formData.append("urlsMantener", JSON.stringify(urlsMantener));
  }

  if (archivos.length > 0) {
    const typeFileArrayOrdenado = archivos.map((item) => item.type);
    formData.append("typeFile", JSON.stringify(typeFileArrayOrdenado));
    archivos.forEach(({ file }) => {
      formData.append("imagenes", file);
    });
  }

  // =====================================================
  // 5. ENVIAR AL BACKEND
  // =====================================================
  try {
    const response = await AlmacenarSoportesVisitaTecnicasostenibilidad(formData);
    return response;
  } catch (error) {
    return { status: 500, message: "Error al subir archivos" };
  }
};

  const handleChange = (newSelectedKeys) => {
    const selectedParticipantsData = newSelectedKeys
      .map((key) => {
        return listaParticipantesSostenibilidadByProyecto.find(
          (participant) => participant.id.toString() === key.toString()
        );
      })
      .filter(Boolean);

    setSelectedParticipants(selectedParticipantsData);
    form.setFieldsValue({ participantes: selectedParticipantsData });
  };

  // Convertir la lista a un formato adecuado para el Transfer
  const dataSource = listaParticipantesSostenibilidadByProyecto.map((item) => ({
    key: item.id.toString(), // Ant Design requiere que las keys sean strings
    title: `${item.codigo_sirr} - ${item.nombre_completo}`,
    tipo_participante: item.tipo_participante,
  }));

  const handleCancel = () => {
    Modal.confirm({
      title: "¿Estás seguro?",
      content:
        "Si cierras, se perderán los datos diligenciados del participante.",
      onOk: () => {
        formParticipante.resetFields(); // Limpiar los campos del formulario
        setDepartamentoSeleccionado("");
        setMunicipios([]);
        setDepartamentos([]);
        setDrawerVisible(false); // Cerrar el Drawer
      },
      onCancel() {
        // No hacer nada si el usuario cancela
      },
    });
  };


    const isAllReady = allImagesReady();
  const hayCarga = Object.values(loadingStatus).some(v => v === true);
  return (
    <div className="form-container">
      <Card className="form-card">
        <Title level={2} className="main-title">
          ACTA DE VISITA IMPLEMENTACIÓN COMPONENTE FORMACIÓN Y ACOMPAÑAMIENTO
          ESTRATEGIA DE SOSTENIBILIDAD{" "}
        </Title>
        <Form form={form} 
              onFinish={onFinish}  
              onValuesChange={onValuesChange}
              layout="vertical">
          <Col xs={24} sm={24}>
                  <Tag color="#D0E0F2" style={tagStyle}>
            TEMÁTICAS DE LA VISITA
          </Tag>
           </Col>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24}>
              <Form.List name="lista_factores">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, fieldKey }, index) => (
                      <Space
                        key={key}
                        align="baseline"
                        className="block-display-important"
                        style={{ marginTop: 20 }}
                      >
                        <Row gutter={[16, 16]} key={key}>
                          {/* Factor */}
                          <Col xs={24} sm={8}>
                            <Form.Item
                              label="Factor"
                              name={[name, "factor"]}
                              fieldKey={[fieldKey, "factor"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Por favor seleccione un factor",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                value={selectedFactor}
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                  handleFactorChange(value, index);
                                  const selectedFactor = factores.find(
                                    (item) => item.key === value
                                  );
                                  if (selectedFactor) {
                                    form.setFieldsValue({
                                      lista_factores: form
                                        .getFieldValue("lista_factores")
                                        .map((item, i) =>
                                          i === index
                                            ? {
                                                ...item,
                                                factor: selectedFactor.factor,
                                              }
                                            : item
                                        ),
                                    });
                                  }
                                }}
                              >
                                {factores.length > 0 ? (
                                  factores.map((item) => (
                                    <Option key={item.key} value={item.factor}>
                                      {item.factor}
                                    </Option>
                                  ))
                                ) : (
                                  <Option disabled>
                                    No hay factores disponibles
                                  </Option>
                                )}
                              </Select>
                            </Form.Item>
                          </Col>

                          {/* Actividad */}
                          <Col xs={24} sm={8}>
                            <Form.Item
                              label="Actividad"
                              name={[name, "actividad"]}
                              fieldKey={[fieldKey, "actividad"]}
                              rules={[
                                {
                                  required: true,
                                  message: "Por favor seleccione una actividad",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                  handleActividadChange(value, index);
                                  const selectedActividad =
                                    actividadesFiltradas[index]?.find(
                                      (item) => item.key === value
                                    );
                                  if (selectedActividad) {
                                    // Almacena tanto la key como la descripción
                                    form.setFieldsValue({
                                      lista_factores: form
                                        .getFieldValue("lista_factores")
                                        .map((item, i) =>
                                          i === index
                                            ? {
                                                ...item,
                                                actividad:
                                                  selectedActividad.actividad,
                                              }
                                            : item
                                        ),
                                    });
                                  }
                                }}
                              >
                                {actividadesFiltradas[index] ? (
                                  actividadesFiltradas[index].length > 0 ? (
                                    actividadesFiltradas[index].map((i) => (
                                      <Option key={i.key} value={i.actividad}>
                                        {i.actividad}
                                      </Option>
                                    ))
                                  ) : (
                                    <Option disabled value="">
                                      No hay actividades disponibles
                                    </Option>
                                  )
                                ) : (
                                  <Option disabled value="">
                                    Cargando actividades...
                                  </Option>
                                )}
                              </Select>
                            </Form.Item>
                          </Col>

                          {/* Sub Actividad */}
                          <Col xs={24} sm={7}>
                            <Form.Item
                              label="Sub Actividad"
                              name={[name, "subActividad"]}
                              fieldKey={[fieldKey, "subActividad"]}
                              rules={[
                                {
                                  required: true,
                                  message:
                                    "Por favor seleccione una Sub actividad",
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                onChange={(value) => {
                                  const selectedSubActividad =
                                    subActividadesFiltradas[index]?.find(
                                      (item) => item.key === value
                                    );
                                  if (selectedSubActividad) {
                                    // Almacena tanto la key como la descripción
                                    form.setFieldsValue({
                                      lista_factores: form
                                        .getFieldValue("lista_factores")
                                        .map((item, i) =>
                                          i === index
                                            ? {
                                                ...item,
                                                subActividad:
                                                  selectedSubActividad.title,
                                              }
                                            : item
                                        ),
                                    });
                                  }
                                }}
                              >
                                {subActividadesFiltradas[index] ? (
                                  subActividadesFiltradas[index].length > 0 ? (
                                    subActividadesFiltradas[index].map((i) => (
                                      <Option key={i.key} value={i.title}>
                                        {i.title}
                                      </Option>
                                    ))
                                  ) : (
                                    <Option disabled value="">
                                      No hay sub actividades disponibles
                                    </Option>
                                  )
                                ) : (
                                  <Option disabled value="">
                                    Cargando sub actividades...
                                  </Option>
                                )}
                              </Select>
                            </Form.Item>
                          </Col>

                          {/* Botón de eliminar */}
                          <Col
                            xs={24}
                            sm={1}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                            }}
                          >
                            <Popconfirm
                              title="¿Está seguro de eliminarlo?"
                              okText="Sí"
                              cancelText="No"
                              onConfirm={() => remove(name)}
                            >
                              <MinusCircleOutlined />
                            </Popconfirm>
                          </Col>
                        </Row>
                      </Space>
                    ))}
                    <Form.Item>
                      <Button type="dashed" block onClick={() => add()}>
                        Agregar temática
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            {/*Campo - Fecha del registro */}
            <Col xs={24} sm={8}>
              <Form.Item label="Fecha de Registro" name="fecha_registro">
                <Input disabled={
                    usernameFromState?.username !== "admin" &&
                    usernameFromState?.username !== "Liliana"
                  } />
              </Form.Item>
            </Col>

            {/*Campo - Numero de visita */}
            <Col xs={24} sm={8}>
              <Form.Item label="Numero de la visita" name="numero_visita">
                <Input disabled={
                    usernameFromState?.username !== "admin"} />
              </Form.Item>
            </Col>
            {/*Campo - Grupo territorial */}

            <Col xs={24} sm={8}>
              <Form.Item label="Grupo territorial" name="grupoTerritorial">
                <Input disabled type="text" />
              </Form.Item>
            </Col>

            {/*Campo - Departamento */}
            <Col xs={24} sm={8}>
              <Form.Item
                label="Departamento"
                name="departamento"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingresa el departamento",
                  },
                ]}
              >
                <Select disabled onChange={handleDepartamentoChange}>
                  {departamentos.map((depto) => (
                    <Option key={depto.id} value={depto.nombre}>
                      {depto.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            {/*Campo - Municipio */}
            <Col xs={24} sm={8}>
              <Form.Item
                label="Municipio"
                name="municipio"
                rules={[
                  { required: true, message: "Por favor ingresa el municipio" },
                ]}
              >
                <Select disabled>
                  {municipios.map((mun) => (
                    <Option
                      key={mun.nombre_municipio}
                      value={mun.nombre_municipio}
                    >
                      {mun.nombre_municipio}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/*Campo - Vereda */}
            <Col xs={24} sm={8}>
              <Form.Item label="Vereda" name="vereda">
                <Input />
              </Form.Item>
            </Col>

            {/*Campo - Código PRE-PP */}
            <Col xs={24} sm={8}>
              <Form.Item label="Código PRE-PP" name="codigoPREPP">
                <Input disabled />
              </Form.Item>
            </Col>
            {/*Campo - Nombre del proyecto o iniciativa productiva */}
            <Col xs={24} sm={8}>
              <Form.Item
                label="Nombre del proyecto o iniciativa productiva"
                name="nombreProyecto"
              >
                <Input disabled />
              </Form.Item>
            </Col>
            {/*Campo - Nombre de la forma asociativa */}
            <Col xs={24} sm={8}>
              <Form.Item
                label="Nombre de la forma asociativa"
                name="nombreFormaAsociativa"
              >
                <Input disabled />
              </Form.Item>
            </Col>

            {/* Campo - Hora de Inicio */}
            <Col xs={24} sm={8}>
              <Form.Item
                label="Hora de Inicio"
                name="horaInicio"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingresa la hora de inicio",
                  },
                ]}
              >
                <TimePicker format="hh:mm a" />
              </Form.Item>
            </Col>
            {/* Campo - Hora de Finalización */}
            <Col xs={24} sm={8}>
              <Form.Item
                label="Hora de Finalización"
                name="horaFin"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingresa la hora de fin",
                  },
                ]}
              >
                <TimePicker format="hh:mm a" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                # DE PERSONAS QUE PARTICIPAN DE LA VISITA
              </Tag>
            </Col>
            {/* Campo - Número de Hombres */}
            <Col xs={24} sm={12}>
              <Form.Item label="Número de Hombres" name="numeroHombres">
                <Input type="number" />
              </Form.Item>
            </Col>
            {/* Campo - Número de Mujeres*/}
            <Col xs={24} sm={12}>
              <Form.Item label="Número de Mujeres" name="numeroMujeres">
                <Input type="number" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                PUNTO DE GEOREFERENCIA
              </Tag>
            </Col>
            <Col xs={24} sm={12}>
              {/* Botón de ubicación */}
              <Button
                icon={<AimOutlined />}
                onClick={handleLocateClick}
                style={{ marginBottom: "16px" }}
              >
                Usar mi ubicación
              </Button>
              {/* Mapa - Aumentando el tamaño */}
              <div
                style={{ height: "300px", width: "100%", marginBottom: "16px" }}
              >
                <MapContainer
                  center={markerPosition}
                  zoom={13}
                  style={{ height: "100%", width: "100%" }}
                  ref={mapRef}
                >
                  <LayersControl position="topright">
                    <BaseLayer checked name="OpenStreetMap">
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      />
                    </BaseLayer>
                    <BaseLayer name="OpenTopoMap">
                      <TileLayer
                        url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://opentopomap.org">OpenTopoMap</a> contributors'
                      />
                    </BaseLayer>
                    <BaseLayer name="OpenStreetMap H.O.T.">
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      />
                    </BaseLayer>
                  </LayersControl>
                  <LocationMarker />
                </MapContainer>
              </div>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                name="latuser"
                label="Latitud"
                rules={[
                  { required: true, message: "Por favor ingresa la latitud" },
                ]}
              >
                <Input placeholder="Latitud" value={latitude} />
              </Form.Item>

              <Form.Item
                name="lnguser"
                label="Longitud"
                rules={[
                  { required: true, message: "Por favor ingresa la longitud" },
                ]}
              >
                <Input placeholder="Longitud" value={longitude} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Linea productiva del proyecto"
                name="linea_productiva"
              >
                <Select
                  disabled={true}
                  placeholder="Seleccionar"
                  onChange={(value) => {
                    setIsOtra(value === "Otra"); // Cambia el estado si se selecciona "Otra"
                    if (value !== "Otra") {
                      form.setFieldsValue({ otra_linea_productiva: "" }); // Limpiar el campo si no es "Otra"
                    }
                  }}
                >
                  <Option value="Agrícola">Agrícola</Option>
                  <Option value="Pecuaria">Pecuaria</Option>
                  <Option value="Servicios">Servicios</Option>
                  <Option value="Comercial">Comercial</Option>
                  <Option value="Industrial">Industrial</Option>
                  <Option value="Otra">Otra</Option>
                </Select>
              </Form.Item>
            </Col>
            {isOtra && ( // Muestra el campo adicional solo si isOtra es verdadero
              <Col xs={24} sm={12}>
                <Form.Item
                  label="Especificar otra línea productiva"
                  name="otra_linea_productiva"
                >
                  <Input placeholder="Especificar" />
                </Form.Item>
              </Col>
            )}
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                ASPECTOS METODOLÓGICOS
              </Tag>
            </Col>
            {/*Campo - Tipo de actividad */}
            <Col xs={24} sm={8}>
              <Form.Item
                label="Tipo de actividad"
                name="tipoActividad"
                rules={[
                  {
                    required: true,
                    message: "Por favor seleccione un tipo de actividad",
                  },
                ]}
              >
                <Select placeholder="Seleccionar">
                  <Option value="Formación">Formación</Option>
                  <Option value="Gestión">Gestión</Option>
                </Select>
              </Form.Item>
            </Col>
            {/*Campo - Modalidad de sesión */}
            <Col xs={24} sm={8}>
              <Form.Item
                label="Modalidad de sesión"
                name="modalidad_sesion_capacitacion"
                rules={[
                  {
                    required: true,
                    message: "Por favor seleccione una modalidad se seción",
                  },
                ]}
              >
                <Select
                  placeholder="Seleccionar"
                  disabled={isEditing}
                  onChange={(value) => {
                    setModalidadSesionCapacitacion(value === "OTRO"); // Cambia el estado si se selecciona "Otra"
                    if (value !== "OTRO") {
                      form.setFieldsValue({
                        otra_modalidad_sesion_capacitacion: "",
                      }); // Limpiar el campo si no es "Otra"
                    }
                  }}
                >
                  <Option value="Visita técnica">Visita técnica</Option>
                  <Option value="ECA">ECA</Option>
                  <Option value="Taller">Taller</Option>
                  <Option value="Gira técnica">Gira técnica</Option>
                  <Option value="Dia de campo">Dia de campo</Option>
                  <Option value="Centros demostrativos de demostración">
                    Centros demostrativos de demostración
                  </Option>

                  <Option value="Otro">Otro</Option>
                </Select>
              </Form.Item>
            </Col>

            {modalidadSesionCapacitacion && ( // Muestra el campo adicional solo si isOtra es verdadero
              <Col xs={24} sm={8}>
                <Form.Item
                  label="Especificar otra modalidad de sesión capacitación"
                  name="otra_modalidad_sesion_capacitacion"
                >
                  <Input placeholder="Especificar" />
                </Form.Item>
              </Col>
            )}
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                ACTIVIDADES DESARROLLADAS EN LA VISITA
              </Tag>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item
                label="En este apartado se debe describir las actividades desarrolladas de acuerdo al factor y la temática seleccionada al inicio de la jornada… Temas abordados y que han sido seleccionados desde el análisis de capacidades"
                name="actividadesDesarrolladas"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                AVANCE DE ACTIVIDADES POR FACTORES DE SOSTENIBILIDAD
              </Tag>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 1. Acompañamiento y fortalecimiento técnico y financiero"
                name="avanceFactor1"
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Recomendaciones brindadas por tema y resultados de avance (analisis de la situacion con la que encontre inicialmnete la unidad de negocio y como lo veo actualmente) Tener en cuenta las diferentes cariables del proyecto."
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 2. Fortalecimiento organizativo y asociativo"
                name="avanceFactor2"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de Actividades: Factor 3. Acompañamiento y fortalecimiento a procesos de mercadeo y comercialización"
                name="avanceFactor3"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 4. Acompañamiento y gestión para la articulación e incidencia territorial"
                name="avanceFactor4"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 5. Acompañamiento para la Implementación de los enfoques diferenciales"
                name="avanceFactor5"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 6. Generación de condiciones para el acceso a tierra"
                name="avanceFactor6"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 7. Promoción de la articulación interinstitucional para la seguridad humana en los territorios"
                name="avanceFactor7"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Avance de actividades Factor 8. Acompañamiento para la implementación de los planes/programas de manejo ambiental (PMA) y el fortalecimiento de relaciones sostenibles entre seres humanos y otras formas de vida"
                name="avanceFactor8"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Próxima Sesión" name="proximaSesion">
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                HALLAZGOS
              </Tag>
            </Col>
            <Col xs={24} sm={24}>
              <Form.Item
                label="Incluir situaciones encontradas como dificultades o particularidades de las intervenciones realizadas de cualquier índole, con el fin de dejar trazabilidad de todo el proceso. Reportar posibles alertas tempranas en el presente documento con el fin de dejar la trazabilidad respectiva, así como las alternativas analizadas entre todas las partes. Reportar, si aplica, posibles casos de éxito del proyecto productivo o información relacionada que sirva a la contextualización del proceso de asistencia técnica."
                name="hallazgos"
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </Col>
          </Row>

          <Tag color="#D0E0F2" style={tagStyle}>
            ACUERDOS
          </Tag>
          <Form.List name="acuerdos">
            {(fields, { add, remove }) => (
              <>
                <Row gutter={16}>
                  <Col xs={8}>
                    <strong>Compromiso</strong>
                  </Col>
                  <Col xs={8}>
                    <strong>Responsable</strong>
                  </Col>
                  <Col xs={7}>
                    <strong>Fecha Límite</strong>
                  </Col>
                  <Col xs={1}></Col>
                </Row>
                {fields.map(({ key, name, fieldKey, ...restField }) => (
                  <Row gutter={16} key={key} style={{ marginTop: "10px" }}>
                    <Col xs={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "compromiso"]}
                        fieldKey={[fieldKey, "compromiso"]}
                      >
                        <Input placeholder="Compromiso" />
                      </Form.Item>
                    </Col>
                    <Col xs={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "responsable"]}
                        fieldKey={[fieldKey, "responsable"]}
                      >
                        <Input placeholder="Responsable" />
                      </Form.Item>
                    </Col>
                    <Col xs={7}>
                      <Form.Item
                        {...restField}
                        name={[name, "fechaLimite"]}
                        fieldKey={[fieldKey, "fechaLimite"]}
                      >
                        <DatePicker
                          placeholder="Fecha Límite"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={1}>
                      <Popconfirm
                        title="¿Está seguro de que desea eliminar este acuerdo?"
                        onConfirm={() => remove(name)}
                        okText="Sí"
                        cancelText="No"
                      >
                        <Button
                          type="link"
                          icon={<DeleteOutlined style={{ color: "red" }} />}
                        />
                      </Popconfirm>
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block>
                    Agregar Acuerdo
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>

          <Row gutter={16}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                FIRMAS
              </Tag>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Firma profesional asistente técnico"
                name="firmaProfesionalAsistenteTecnico"
              >
                <FirmaCanvas
                  label="Firma profesional asistente técnico"
                  name="firmaProfesionalAsistenteTecnico"
                  form={form}
                  formLoaded={formLoaded}
                  modoFirma= "url"

                />
              </Form.Item>

              <Form.Item
                label="Nombre profesional asistencia técnica"
                name="nombreProfesionalAsistenteTecnico"
              >
                <Input type="text" />
              </Form.Item>
              <Form.Item label="Cedula" name="ccProfesionalAsistenteTecnico">
                <Input type="number" />
              </Form.Item>

              <Form.Item
                label="Profesión"
                name="ProfesionProfesionalAsistenteTecnico"
              >
                <Input type="text" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label="Firma profesional asistente técnico"
                name="firmaProfesionalAsistenteTecnico_2"
              >
                <FirmaCanvas
                  label="Firma profesional asistente técnico 2"
                  name="firmaProfesionalAsistenteTecnico_2"
                  form={form}
                  formLoaded={formLoaded}
                  modoFirma= "url"

                />
              </Form.Item>

              <Form.Item
                label="Nombre profesional asistencia técnica"
                name="nombreProfesionalAsistenteTecnico_2"
              >
                <Input type="text" />
              </Form.Item>
              <Form.Item label="Cedula" name="ccProfesionalAsistenteTecnico_2">
                <Input type="number" />
              </Form.Item>

              <Form.Item
                label="Profesión"
                name="ProfesionProfesionalAsistenteTecnico_2"
              >
                <Input type="text" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24}>
              <Tag color="#D0E0F2" style={tagStyle}>
                LISTA DE PARTICIPANTES
              </Tag>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Card bordered style={{ overflow: "hidden" }}>
                <Button
                  type="primary"
                  style={{
                    width: "10%",
                    marginTop: "24px",
                    backgroundColor: "#52c41a",
                    borderColor: "#52c41a",
                  }}
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setModalKey((prevKey) => prevKey + 1);
                    setDrawerVisible(true);
                  }}
                >
                  Nuevo
                </Button>

                <Transfer
                  dataSource={dataSource || []}
                  titles={["Disponibles", "Seleccionados"]}
                  targetKeys={
                    Array.isArray(selectedParticipants)
                      ? selectedParticipants.map((p) => p.id?.toString())
                      : []
                  }
                  onChange={handleChange}
                  showSearch
                  render={(item) => ({
                    label: (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <span>{item.title}</span>
                        <Tag
                          color={
                            item.tipo_participante === "Asociado"
                              ? "green"
                              : "blue"
                          }
                        >
                          {item.tipo_participante}
                        </Tag>
                      </div>
                    ),
                    value: `${item.title}`,
                  })}
                  listStyle={{
                    width: "100%",
                    maxWidth: "100%",
                    height: 300,
                    overflow: "auto",
                  }}
                />
              </Card>
            </Col>

            {/* Selector del modo firma */}
            <Card title="Modo de Firma" bordered>
              <Form.Item
                name="modoFirma"
                rules={[
                  {
                    required: true,
                    message: "Debe seleccionar un modo de firma",
                  },
                ]}
              >
                <Radio.Group
                  value={modoFirma}
                  onChange={(e) => {
                    setModoFirma(e.target.value);
                    form.setFieldsValue({ modoFirma: e.target.value }); // 🔑 sincronizar con Form
                  }}
                >
                  <Radio value="firma_participantes">
                    Firma directa en pantalla
                  </Radio>
                  <Radio value="anexo_firma_participantes">
                    Cargar anexo con firmas
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Card>

            <Col xs={24} sm={24} md={24}>
              <Card title="Participantes Seleccionados" bordered>
                {Array.isArray(selectedParticipants) &&
                selectedParticipants.length > 0 ? (
                  <>
                    {modoFirma === "firma_participantes" && (
                      <Row gutter={[16, 16]}>
                        {selectedParticipants.map((participant) => (
                          <Col span={12} key={participant.id}>
                            <p>
                              {participant.codigo_sirr} -{" "}
                              {participant.nombre_completo}
                            </p>
                            <Form.Item
                              label="Firma Participante"
                              rules={[
                                {
                                  required: true,
                                  message: "Debe de firmar el participante",
                                },
                              ]}
                              name={`firmaParticipante_${participant.id}`}
                            >
                              <FirmaCanvas
                                label="Firma Participante"
                                name={`firmaParticipante_${participant.id}`}
                                form={form}
                                formLoaded={formLoaded}
                                modoFirma="url"
                              />
                            </Form.Item>
                          </Col>
                        ))}
                      </Row>
                    )}

                    {modoFirma === "anexo_firma_participantes" && (
                      <Form.Item
                        label="Anexo de Firmas"
                        name="anexoFirmas"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          if (Array.isArray(e)) return e;
                          return e?.fileList;
                        }}
                        rules={[
                          {
                            required: true,
                            message: "Debe cargar el anexo en formato PDF",
                          },
                        ]}
                      >
                        <Upload
                          beforeUpload={(file) => {
                            const isPDF = file.type === "application/pdf";
                            if (!isPDF) {
                              message.error(
                                "Solo se permiten archivos en formato PDF"
                              );
                              return Upload.LIST_IGNORE; // evita que se agregue
                            }
                            return false; // evita subida automática, se maneja manual
                          }}
                          maxCount={1} // solo un archivo
                          accept=".pdf" // 🔹 solo permite seleccionar PDF en el diálogo
                          onChange={({ fileList }) => {
                            // 🔹 mantener solo 1 archivo (último cargado)
                            if (fileList.length > 1) {
                              fileList = [fileList[fileList.length - 1]];
                            }
                            form.setFieldsValue({ anexoFirmas: fileList });
                          }}
                        >
                          <Button icon={<UploadOutlined />}>
                            Subir archivo PDF
                          </Button>
                        </Upload>
                      </Form.Item>
                    )}
                  </>
                ) : (
                  <p>No hay participantes seleccionados</p>
                )}
              </Card>
            </Col>
          </Row>

          {/* Campo oculto para almacenar la selección en el formulario */}
          <Form.Item name="participantes" hidden>
            <input type="hidden" />
          </Form.Item>


            
               <Form.Item name="fotografia_participantes">
                 <ImagenUploader
                  titulo="FOTOGRAFÍA  CON LOS PARTICIPANTES DESARROLLANDO LAS ACTIVIDADES"
                  onChange={handleFotografiaParticipantesChange}
                  value={initialData?.fotografia_participantes}
                  onLoadingChange={handleLoadingChange}
                  onStatusChange={handleStatusChange}  // <-- NUEVA PROP
                  name="fotografia_participantes"   // <--- AGREGAR
                />
               </Form.Item>
               <Form.Item name="fotografias_lugar">
            <ImagenUploader
              titulo="FOTOGRAFÍA  (BUENA DEFINICIÓN) EN EL LUGAR DONDE SE DESARROLLA EL PROYECTO PRODUCTIVO"
              onChange={handleFotografiasLugarChange}
              value={initialData?.fotografias_lugar}
              onLoadingChange={handleLoadingChange}
              onStatusChange={handleStatusChange}
              name="fotografias_lugar"
            />
               </Form.Item>
               <Form.Item name="fotografia_finalidad">
            <ImagenUploader
              titulo="FOTOGRAFÍA  (BUENA DEFINICIÓN), QUE REPRESENTE LA FINALIDAD DEL PROYECTO PRODUCTIVO"
              onChange={handleFotografiaFinalidadChange}
              value={initialData?.fotografia_finalidad}
              onLoadingChange={handleLoadingChange}
              onStatusChange={handleStatusChange}
              name="fotografia_finalidad"
            />
               </Form.Item>
               <Form.Item name="fotografia_acta">
            <ImagenUploader
              titulo="FOTOGRAFÍA (BUENA DEFINICIÓN) CON EL USUARIO DILIGENCIANDO EL ACTA DE LA VISITA"
              onChange={handleFotografiaActaChange}
              value={initialData?.fotografia_acta}
              onLoadingChange={handleLoadingChange}
              onStatusChange={handleStatusChange}
              name="fotografia_acta"
            />
               </Form.Item>
               <Form.Item name="fotografia_actividad">
                         <ImagenUploader
                           titulo="FOTOGRAFÍA (BUENA DEFINICIÓN) DONDE SE EVIDENCIE UNA ACTIVIDAD PROPIA DEL PROYECTO PRODUCTIVO"
                           onChange={handleFotografiaActividadChange}
                           value={initialData?.fotografia_actividad}
                           onLoadingChange={handleLoadingChange}
                           onStatusChange={handleStatusChange}
                           name="fotografia_actividad"
                         />
               </Form.Item>

            <div style={{ textAlign: "center", marginTop: "40px" }}>
                     {/* Ocultar o deshabilitar el botón de consultar si está en edición */}
         
                     <Button
                       type="primary"
                       htmlType="submit"
                       style={{
                         backgroundColor: isAllReady ? "#52c41a" : "#d9d9d9",
                         borderColor: isAllReady ? "#52c41a" : "#d9d9d9",
                       }}
                       loading={isLoading}
                       disabled={!isDirty || !isAllReady}
                     >
                       {isEditing ? "Actualizar Visita Técnica" : "Guardar Visita Técnica"}
                     </Button>
         
                         {/* Mensaje de estado */}
                         {!isAllReady && (
                           <div style={{ marginTop: 16, color: '#cf1322', fontSize: 14 }}>
                             {hayCarga ? (
                               <span><LoadingOutlined spin /> Cargando imágenes, por favor espera...</span>
                             ) : (
                               <span>⚠️ Algunas imágenes no se cargaron correctamente. Revisa los campos con error.</span>
                             )}
                           </div>
                         )}
                   </div>
        </Form>

        {/* Modal para ingresar el código SIRR */}
        <Modal
          title="Consultar código Interno"
          open={modalVisible}
          footer={null}
          closable={true}
          onCancel={() => {
            setModalVisible(false);
            onClose();
          }}
        >
          <Form onFinish={handleConsultar}>
            <Form.Item
              name="codigoInterno"
              rules={[
                {
                  required: true,
                  message: "Por favor selecciona un código interno",
                },
              ]}
            >
              <Select
                placeholder="Selecciona un código interno"
                onChange={(value) => setCodigoInternoModal(value)}
                value={codigoInternoModal}
                style={{ marginBottom: "16px" }}
                showSearch
                optionFilterProp="children"
              >
                {lista_sd_sostenibilidad.map((item) => (
                  <Select.Option key={item.oid} value={item.codigo_interno}>
                    {item.codigo_interno} - {item.implementador}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Button type="primary" htmlType="submit">
              Consultar
            </Button>
          </Form>
        </Modal>
      </Card>

      <Drawer
        open={drawerVisible}
        onClose={handleCancel}
        width={800} // Ajusta el ancho del Drawer
        title="Nuevo Participante"
        style={{
          padding: 0, // Elimina el padding predeterminado del contenido
          textAlign: "center",
          overflowY: "auto", // Añade scroll vertical si el contenido es grande
        }}
      >
        <div className="modal-container">
          <ParticipanteForm
            key={modalKey}
            onClose={() => setDrawerVisible(false)} // Pasa la función de cierre
            form={formParticipante} // Pasa el formulario al componente hijo
            initialData={datosProyecto}
            fetchData={agregarParticipanteLocal}
          />
        </div>
      </Drawer>
    </div>
  );
};

export default FormularioVisitaTecnicaSostenibilidad;
